// define a mixin object
const SetComma = {
  methods: {
    comma(str) {
      if (!str) {
        return "";
      }
      if (typeof str === "number") {
        str = str.toString();
      }
      return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,");
    },
    uncomma(str) {
      if (!str) {
        return "";
      }
      if (typeof str === "number") {
        str = str.toString();
      }

      return str.replace(/[^\d.]+/g, "");
    },
  },
};

export default SetComma;
